<template>
  <a-form :form="form" @submit="getValues">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['1'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-1`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            class="mt-4"
          >
            <a-radio-button v-for="id in Object.keys(questions['1'].a)" :key="id" :value="id">
              {{ questions['1'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :xs="24" :sm="12" v-if="item.maker">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Liutaio / Produttore</label>
          <a-input
            v-decorator="[
              `luthier`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            class="mt-4"
            formErrors
            placeholder=""
          />
        </a-form-item>
      </a-col>

      <a-col :xs="24" :sm="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Modello</label>
          <a-input
            v-decorator="[
              `model`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            class="mt-4"
            formErrors
            placeholder=""
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :xs="24" :sm="12">
        <a-form-item
          :colon="false"
          :has-feedback="!!priceError"
          :validate-status="priceError ? 'error' : ''"
          :help="priceError"
        >
          <label class="font-bold" slot="label">Valore</label>
          <div class="flex items-center mt-4">
            <CurrencyInput
              currency="EUR"
              :distraction-free="false"
              v-model="price"
              :class="['price-input', priceError && 'price-input-error']"
              inputmode="decimal"
              :valueRange="{ min: 1 }"
              :allowNegative="false"
            />
            <a-tooltip
              slot="suffix"
              title="Il valore del bene dovrà essere verificato durante il processo di acquisto tramite il caricamento di perizie di esperti"
            >
              <a-icon
                :style="{ fontSize: '1.25rem' }"
                class="ml-4 cursor-pointer"
                type="info-circle"
                style="color: rgba(0,0,0,.45)"
              />
            </a-tooltip>
          </div>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row></a-row>
  </a-form>
</template>

<script>
import api from '@/api.js';
import questions from '@/questions.js';

export default {
  name: 'instrument-info-form',
  computed: {},

  props: {
    item: Object
  },

  data() {
    return {
      form: this.$form.createForm(this, { name: 'instruments' }),
      questions,
      price: null,
      priceError: null
    };
  },

  methods: {
    getValues() {
      return new Promise((resolve, reject) => {
        let hasErrors = false;

        if (!this.price || this.price <= 0) {
          hasErrors = true;
          this.priceError = "E' un campo obbligatorio";
        } else {
          this.priceError = null;
        }

        this.form.validateFieldsAndScroll(
          { scroll: { offsetTop: 30, alignWithTop: true } },
          async (err, values) => {
            if (err) {
              console.log('Form is invalid: ', values, err);
              reject(err);
            }

            resolve({ ...values, value: this.price });
          }
        );
      });
    }
  }
};
</script>

<style lang="scss">
.ant-checkbox .ant-checkbox-inner {
  height: 1.5rem;
  width: 1.5rem;
}
.ant-checkbox-inner::after {
  top: 40%;
  left: 15%;
  width: 10px;
  height: 18px;
}
.ant-form-item-control {
  line-height: 1.6rem;
}
</style>
